import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { LiquidationReviewHeader } from '../../../../shared/models/liquidation-review-header';
import { PartnerLiquidationReviewItem } from '../../../../shared/models/partner-liquidation-review-item';
import { AdminService } from '../../services/admin';

@Component({
  selector: 'app-liquidation-reviews',
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    RouterModule
  ],
  templateUrl: './liquidation-reviews.html',
  styleUrl: './liquidation-reviews.css'
})
export class LiquidationReviews implements OnInit, AfterViewInit {
  header: LiquidationReviewHeader | null = null;
  dataSource: MatTableDataSource<PartnerLiquidationReviewItem> = new MatTableDataSource<PartnerLiquidationReviewItem>([]);
  displayedColumns: string[] = ['partnerName', 'totalToInvoice', 'totalToDeposit', 'status', 'createdAt', 'actions'];
  private statusTranslations: Record<string, string> = {
    // Estados generales de liquidación (admin)
    'DRAFT'                        : 'Borrador',
    'UPLOADING'                    : 'Subiendo Archivo',
    'PROCESSING_EXCEL'             : 'Procesando Excel',
    'PROCESSED_EXCEL'              : 'Excel procesado',
    'COMPLETED'                    : 'Completada',
    'NOTIFICATIONS_SENT'           : 'Notificaciones enviadas',
    'FAILED_INVALID_UPLOAD_PATH'   : 'Falló: Ruta de Carga Inválida',
    'FAILED_EMPTY_FILE'            : 'Falló: Archivo Vacío',
    'FAILED_INITIAL_STATUS_UPDATE' : 'Falló: Actualización Inicial de Estado',
    'FAILED_INVALID_FILE_TYPE'     : 'Falló: Tipo de Archivo Inválido',
    'FAILED_NO_DATA'               : 'Falló: Sin Datos en Excel',
    'FAILED_FILE_CORRUPT'          : 'Falló: Archivo Corrupto',
    'FAILED_EXCEL_EMPTY_OR_NO_DATA': 'Falló: Excel Vacío o Sin Datos',
    'FAILED_NO_VALID_BUSES'        : 'Falló: Sin Buses Válidos',
    'FAILED_MASTER_DATA_FETCH'     : 'Falló: Error en Carga de Datos Maestros',
    'FAILED_EXCEL_FORMAT'          : 'Falló: Formato de Excel Inválido',
    'FAILED_PROCESSING_ERROR'      : 'Falló: Error de Procesamiento',
    'FAILED_TIMEOUT'               : 'Falló: Tiempo de Espera Excedido',
    // Estados de liquidación de socio
    'PENDING_UPLOAD'               : 'Pendiente de envío',
    'REVIEW_IN_PROGRESS'           : 'En revisión',
    'REJECTED'                     : 'Rechazada',
    'APPROVED'                     : 'Aprobada'
  };

  private liquidationId: string = '';

  @ViewChild(MatSort) set matSort(sort: MatSort) {
    if (sort) {
      this.dataSource.sort = sort;
    }
    this.sort = sort;
  }
  private sort!: MatSort;

  @ViewChild(MatPaginator) set matPaginator(paginator: MatPaginator) {
    if (paginator) {
      this.dataSource.paginator = paginator;
    }
    this.paginator = paginator;
  }
  private paginator!: MatPaginator;

  constructor(private route: ActivatedRoute, private adminService: AdminService) {
    this.dataSource.filterPredicate = (data, filter) => {
      const composed = `${data.partnerName} ${data.status}`.toLowerCase();
      return composed.includes(filter);
    };
  }

  ngOnInit(): void {
    this.liquidationId = this.route.snapshot.paramMap.get('id') || '';
    if(this.liquidationId) {
      this.loadData();
    }
  }

  ngAfterViewInit(): void {
    if (this.sort) {
      this.dataSource.sort = this.sort;
    }
    if (this.paginator) {
      this.dataSource.paginator = this.paginator;
    }
  }

  async loadData(): Promise<void> {
    const result = await this.adminService.getPartnerLiquidationsForReview(this.liquidationId);
    if(result) {
      this.header = result.header;
      this.dataSource.data = result.items;
      if (this.sort) {
        this.dataSource.sort = this.sort;
      }
      if (this.paginator) {
        this.dataSource.paginator = this.paginator;
      }
    }
  }

  applyFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value?.trim().toLowerCase();
    this.dataSource.filter = filterValue;
  }

  getTranslatedStatus(status: string): string {
    return this.statusTranslations[status] || status;
  }
}
